import React, { useMemo, useState } from "react";
import { EmptyState } from "@design-system/EmptyState/EmptyState";
import { ViewTable } from "@design-system/ViewTable/ViewTable";
import { View } from "@common/types/views/views";
import { HistoryDetailsItem } from "@common/types/auditLog";
import historyDetailsStyles from "../HistoryDetails.module.scss";
import { HistoryTaskSnapshotLog } from "./HistoryTaskSnapshotLog";
import { createDefaultHistoryTaskUpdateView } from "./views/defaultHistoryTaskUpdateView";
import {
    HistoryTaskUpdateDetailsRow,
    createHistoryTaskUpdateViewConfig,
} from "./views/historyTaskUpdateDetailsViewConfig";
import styles from "./HistoryTaskLog.module.scss";

interface HistoryTaskCreateDeleteDetailsProps {
    logs: HistoryDetailsItem[];
    footer: React.ReactNode;
}

export const HistoryTaskCreateDeleteDetails: React.FC<
    HistoryTaskCreateDeleteDetailsProps
> = ({ logs, footer }) => {
    if (logs.length === 0) {
        return (
            <div className={styles.taskLogContainer}>
                <div className={styles.taskLogList}>
                    <EmptyState header="No task changes found" />
                </div>
                {footer}
            </div>
        );
    }

    return (
        <div className={styles.taskLogContainer}>
            <div className={styles.taskLogList}>
                {logs.map((log) => (
                    <HistoryTaskSnapshotLog key={log.id} log={log} />
                ))}
            </div>
            {footer}
        </div>
    );
};

interface HistoryTaskUpdateDetailsProps {
    data: HistoryTaskUpdateDetailsRow[];
    footer: React.ReactNode;
}

export const HistoryTaskUpdateDetails: React.FC<
    HistoryTaskUpdateDetailsProps
> = ({ data, footer }) => {
    const [view, setView] = useState<View>(
        createDefaultHistoryTaskUpdateView(),
    );
    const config = useMemo(
        () => createHistoryTaskUpdateViewConfig(data),
        [data],
    );

    return (
        <ViewTable
            data={data}
            view={view}
            config={config}
            onViewChange={setView}
            emptyView={() => <EmptyState header="No task changes found" />}
            footer={footer}
            className={historyDetailsStyles.historyDetailsView}
        />
    );
};
